export { default } from "./CartFooter";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/cartTable/cartFooter/index.js